import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-shortlisting-vendors',
  standalone: false,
  templateUrl: './shortlisting-vendors.component.html',
  styleUrl: './shortlisting-vendors.component.scss'
})
export class ShortlistingVendorsComponent implements OnInit , OnDestroy {
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() step: any;
  @Input() id: any
  @Input() getUrl1: any
  @Input() postUrl1: any
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: any;
  vendors = [];
  criteria = [];
  payload: {
    proposal_id: any;
    proposal_name: any;
    schemeID: any
  };
  apiUrl: string = environment.APIUrl;
  private subscriptions = new Subscription();
  userID: any;
  constructor(private messageService: MessageService, private fb: FormBuilder, private api: ApiService, private route: ActivatedRoute) { 
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      const schemeId = params['scheme'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
        schemeID: schemeId
      }
      this.getStep1();
    });

  }
   ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
 getStep1(): void {
  const proposalId = this.payload.proposal_id;
  const stepId = this.id;
  const schemeId = this.payload.schemeID;

  const isMakeScheme = this.schemeType === 'makeI' || this.schemeType === 'makeII' || this.schemeType === 'makeIII';

  const url = isMakeScheme
    ? `/make1/shorlisting/da/?proposal_step__proposal=${proposalId}&proposal_step=${stepId}&scheme=${schemeId}`
    : `/revenue/eol-documents/?proposal_step__proposal=${proposalId}&proposal_step=${stepId}`;

  //  const url = `/revenue/eol-documents/?proposal_step__proposal=${proposalId}&proposal_step=${stepId}`;


  const sub =this.api.getAPI(url).subscribe((res: any) => {
    this.vendors = this.formatVendors(res);
  });
    this.subscriptions.add(sub);
}

formatVendors(apiResponse: any): any[] {
  const result = [];
  for (const vendorName in apiResponse) {
    const docs = apiResponse[vendorName];

    if (docs.length > 0) {
      const vendorInfo = docs[0].vendor || docs[0].da;

      result.push({
        id: vendorInfo?.id,
        vendorName: vendorName,
        vendor: vendorInfo,
        vendor_status: docs[0].vendor_status,
        documents: docs  // Contains criteria, document, etc.
      });

      // Set final vendor based on first qualified document
      const qualifyingDoc = docs.find(
        doc =>
          doc.vendor_status === 'Qualify' &&
          (this.schemeType === 'makeII' || this.schemeType === 'makeIII') &&
          doc?.id
      );
      if (qualifyingDoc) {
        sessionStorage.setItem('final_vendor', qualifyingDoc.vendor.id);
      }
    }
  }

  return result;
}


  vendorStatusupdate(status: any, docId: number, id: number) {
    const payload = {
      vendor_status: status === 'Qualify' ? 'Qualify' : 'Disqualify'
    };
    let apiUrl
    if (this.schemeType === 'makeI') {
    apiUrl = `/make1/shorlisting/da/${docId}/?vendor_id=${id}`; // docid here is the criteria[0].id for make I only
  } else if (this.schemeType === 'makeII' || this.schemeType === 'makeIII') {
    apiUrl = `/make1/shortlisting/da/${this.payload.proposal_id}/${id}/`;
  }
   else {
    // For other types like revenue
    apiUrl = `/revenue/shortlisting/vendor/${id}/`;
  }
  const sub =  this.api.putAPI(apiUrl, payload).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Vendor status updated successfully'
        });
        this.getStep1()
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Vendor status updated successfully'
        });
        console.error('TNC status update error:', err);
      }
    });
      this.subscriptions.add(sub);
  }
      activeIndex: number | null = null;
  togglePanel(index: number): void {
    this.activeIndex = this.activeIndex === index ? null : index;
  }

}
